import { memo, useCallback, useState } from 'react';
import { Box, Skeleton, Typography, TextField } from '@mui/material';
// Local files
import BaseDialog from 'components/Common/Feedback/BaseDialog/BaseDialog';
import FilePreview from 'components/Common/FilePreview/FilePreview';
import BaseEventsList from 'components/Analyses/Common/BaseEventsList/BaseEventsList';
import useStudyTasks from 'hooks/useStudyTasks';
import useEvents from 'hooks/useEvents';
import useCustomSelector from 'hooks/useCustomSelector';
import { studyTasksSelectors } from "features/studyTasks";
import { eventsSelectors } from "features/events";

const StudyTask = ({ open, taskId, onClose }) => {
  const { getStudyTask, clearLocalActiveStudyTask } = useStudyTasks();
  const { getStudyTasksEvents, clearLocalTasksEvents } = useEvents();
  const { file, input } = useCustomSelector(studyTasksSelectors.getStudyTaskData);
  const fetching = useCustomSelector(studyTasksSelectors.studyTaskIsFetching);
  const { data, pagination } = useCustomSelector(eventsSelectors.getTasksEventsData);
  const eventsFetching = useCustomSelector(eventsSelectors.taskEventsIsFetching);
  const [expanded, setExpanded] = useState(false);
  const [firstTimeEventsOpened, setFirstTimeEventsOpened] = useState(true);

  const fetchStudyTasksEvents = useCallback((offset, taskId) => {
    getStudyTasksEvents({ offset, study_task_id: taskId })
  }, [ getStudyTasksEvents]);

  const handleChangeExpand = (_, isExpanded) => {
    setExpanded(isExpanded);
    if (firstTimeEventsOpened) {
      fetchStudyTasksEvents(0, taskId);
      setFirstTimeEventsOpened(false);
    }
  }
  const handleEntering = () => {
    getStudyTask(taskId);
  };
  const handleExited = () => {
    setExpanded(false);
    setFirstTimeEventsOpened(true);
    clearLocalActiveStudyTask();
    clearLocalTasksEvents();
  };

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      TransitionProps={{ onExited: handleExited, onEntering: handleEntering }}
      otherPaperStyle={{ width: '100%', maxWidth: 800, backgroundColor: 'background.default' }}
      title='Task'
    >
      {fetching ? <Skeleton/> : <Box sx={{ px: 4, pb: 3 }}>
        {!!input && <Box sx={{ mb: '30px' }}>
          <Typography sx={{ fontSize: '1rem', fontWeight: 400, mb: '10px' }}>Input:</Typography>
          <TextField
            fullWidth
            margin='normal'
            label='Input'
            multiline
            minRows={5}
            maxRows={8}
            disabled
            value={input ?? ''}
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#073842",
              }
            }}
          />
        </Box>}
        {file?.id && <Box sx={{ mb: '30px' }}>
          <Typography sx={{ fontSize: '1rem', fontWeight: 400, mb: '10px' }}>File:</Typography>
          <FilePreview
            key={file?.id}
            type={file?.content_type}
            name={file?.filename}
            url={file?.url}
          />
        </Box>}
        <BaseEventsList
          data={data}
          pagination={pagination}
          analysisId={taskId}
          eventsFetching={eventsFetching}
          fetchEvents={fetchStudyTasksEvents}
          expanded={expanded}
          handleChangeExpand={handleChangeExpand}
          expandButton={false}
        />  
      </Box>}
    </BaseDialog>
  );
};

export default memo(StudyTask);